import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { RecordData } from "src/app/types";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";

@Component({
  selector: "vital-recording-card",
  templateUrl: "./vital-recording.component.html",
  styleUrls: ["./recording.component.css"],
  imports: SHARED_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VitalRecordingComponent implements OnInit {
  @Input() recordData: RecordData;

  ngOnInit() {
  }
}
